import { Box, Heading, Spinner, Switch } from '@veracity/vui'
import { useEffect, useState } from 'react'

import { PageLoader } from '@/components'
import { IsoBa } from '@/interfaces'

import { useScenarioResultsSummary } from '../../hooks'
import { ScenarioResultsSummaryTabAdjustmentTable } from './ScenarioResultsSummaryTabAdjustmentTable'
import { ScenarioResultsSummaryTabInfoSection } from './ScenarioResultsSummaryTabInfoSection'

interface Props {
  scenarioId: number
}

export const ScenarioResultsSummaryTab = ({ scenarioId }: Props) => {
  const [applyIncomeAdjustments, setApplyIncomeAdjustments] = useState(true)
  const [isFirstResult, setIsFirstResult] = useState(true)

  const { summaryInfo, isFetching, isRefetching } = useScenarioResultsSummary(
    scenarioId,
    applyIncomeAdjustments
  )

  useEffect(() => {
    if (isFirstResult && summaryInfo) {
      setApplyIncomeAdjustments(summaryInfo?.isoBa !== IsoBa.ES_PENINSULA)
      setIsFirstResult(false)
    }
  }, [isFirstResult, summaryInfo])

  return isFetching ? (
    <PageLoader />
  ) : (
    <Box column p={2} gap={3} bg="white">
      {!!summaryInfo && (
        <ScenarioResultsSummaryTabInfoSection summaryInfo={summaryInfo} />
      )}

      <Box justify="space-between">
        <Heading size="h5">
          {applyIncomeAdjustments
            ? 'Annual income prior to adjustment'
            : 'Annual income post adjustment'}
        </Heading>

        <Switch
          checked={applyIncomeAdjustments}
          disabled={summaryInfo?.isoBa === IsoBa.ES_PENINSULA} // Temporary disable switch for ES_PENINSULA
          onChange={ev => setApplyIncomeAdjustments(ev.target.checked)}
          labelRight="Apply income adjustment factor"
        />
      </Box>

      {isRefetching ? (
        <Spinner size="lg" />
      ) : (
        <ScenarioResultsSummaryTabAdjustmentTable
          isoType={summaryInfo?.isoBa}
          systemConfiguration={summaryInfo?.systemConfiguration}
          summaryResults={summaryInfo?.bessOperatingIncomeResults || []}
        />
      )}
    </Box>
  )
}
